export const ANSWER_STEP_ORDER = [
  { field: 'productCount', step: 'productCount', nextStep: 'foodService' },
  { field: 'foodServiceBulkItems', step: 'foodService', nextStep: 'alcoholic' },
  { field: 'variableWeight', step: 'foodService', nextStep: 'alcoholic' },
  {
    field: 'alcoholicBeverages',
    step: 'alcoholic',
    nextStep: 'retailInnerPack',
  },
  {
    field: 'sellableInnerPack',
    step: 'retailInnerPack',
    nextStep: 'storeDisplay',
  },
  {
    field: 'displayShippers',
    step: 'storeDisplay',
    nextStep: 'merchandisedInTray',
  },
  {
    field: 'shelfDisplayBoxTray',
    step: 'merchandisedInTray',
    nextStep: 'multipack',
  },
  { field: 'multipacks', step: 'multipack', nextStep: 'perishable' },
  { field: 'perishable', step: 'perishable', nextStep: null }, // After this, recommendation is calculated
];

/**
 * Check if a value is considered "answered"
 * null/undefined = not answered, any other value (including false, 0) = answered
 */
const isAnswered = (value) => {
  return value !== null && value !== undefined;
};

/**
 * Determine the step to navigate to based on saved answers
 * Returns the first unanswered step, or the recommendation step if all answered
 */
export const determineCurrentStep = (formData) => {
  const history = ['intro'];

  for (const { field, step } of ANSWER_STEP_ORDER) {
    const value = formData[field];

    if (!isAnswered(value)) {
      // This step is not answered yet - navigate here
      return {
        step,
        history,
      };
    }

    // This step was answered, add to history
    if (history[history.length - 1] !== step) {
      history.push(step);
    }
  }

  // All questions answered - determine recommendation based on answers
  const recommendationStep = determineRecommendationStep(formData);
  history.push(recommendationStep);

  return {
    step: recommendationStep,
    history,
  };
};

export const determineRecommendationStep = (formData) => {
  const { productCount } = formData;

  // Based on product count
  if (productCount > 15) {
    return 'recommendTemplate';
  }

  return 'recommendGrid';
};

export const buildWizardStep = (formData) => {
  const { step, history } = determineCurrentStep(formData);

  return {
    currentStep: step,
    history,
    wizardFormId: formData.wizardFormId,
    answers: {
      productCount: formData.productCount,
      foodServiceBulkItems: formData.foodServiceBulkItems,
      variableWeight: formData.variableWeight,
      alcoholicBeverages: formData.alcoholicBeverages,
      beer: formData.beer,
      wine: formData.wine,
      spirits: formData.spirits,
      sellableInnerPack: formData.sellableInnerPack,
      displayShippers: formData.displayShippers,
      shelfDisplayBoxTray: formData.shelfDisplayBoxTray,
      perishable: formData.perishable,
      multipacks: formData.multipacks,
    },
    arrivalDate: formData.arrivalDate,
  };
};
